import htmx from 'htmx.org';
import Alpine from 'alpinejs';
import { preseedForm } from './preseed-form.js';

htmx.config.includeIndicatorStyles = false;
// Work against 'unsafe-inline' CSP.
htmx.config.includeIndicatorStyles = false;
// Work against 'unsafe-eval' CSP.
htmx.config.selfRequestsOnly = true;
htmx.config.allowScriptTags = false;
htmx.config.allowEval = false;

globalThis.htmx = htmx;
globalThis.Alpine = Alpine;
globalThis.preseedForm = preseedForm;

globalThis.themeToggle = () => ({
  dark: localStorage.getItem('theme') === 'dark' ||
    (!localStorage.getItem('theme') && globalThis.matchMedia('(prefers-color-scheme: dark)').matches),
  toggle() {
    this.dark = !this.dark;
    localStorage.setItem('theme', this.dark ? 'dark' : 'light');
  },
});

Alpine.start();

document.body.addEventListener('htmx:afterSwap', function (evt) {
  if (evt.target.id === 'form-errors') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});
